var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeWidth":"2.5","d":"m15 9.5-7-7-7 7"}));
}

ChevronUp.defaultProps = {"width":"16","height":"11","fill":"none","viewBox":"0 0 16 11"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
